import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, take } from 'rxjs';
import { AuthService } from '@/app/services/auth.service';

/**
 * Allow only global admins. Realm-scoped admins are redirected to "/".
 * Use for routes whose underlying admin API endpoints require global access
 * (e.g. Companies — listCompanies / createCompany / etc. all enforce
 * `IsGlobalAdmin` server-side).
 */
export const globalAdminGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    return toObservable(authService.sessionInitialized).pipe(
        filter((initialized) => initialized),
        take(1),
        map(() => (authService.isGlobalAdmin() ? true : router.createUrlTree(['/']))),
    );
};
